export const formatCurrency = (value, format) => {
  if (!format) {
    return `$${value}`;
  }

  return format.replace('{value}', value);
};
